/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_TitleInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_4_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check more than the total`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_4_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查范围不止合计数字`)
};

/**
* | output |
* | --- |
* | "Check more than the total" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_4_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_4_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_4_title(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_4_title(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_4_title as "gc.search_guides.gridcraft_excel_compatibility.sections.4.title" }